import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BadgeCheck, ArrowRight, ShieldCheck } from "lucide-react";
import api, { mediaUrl, formatRON } from "@/lib/api";

const PLACEHOLDER = "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?crop=entropy&cs=srgb&fm=jpg&q=80&w=940";

export const ShowroomStrip = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/listings/featured").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section className="bg-slate-900 text-white -mx-6 px-6 py-10 mb-10" data-testid="showroom-strip">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between gap-4 flex-wrap mb-6">
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center gap-2 bg-amber-500 text-slate-900 text-xs font-black uppercase tracking-widest px-3 py-1.5">
              <ShieldCheck className="w-4 h-4" /> Showroom OXO
            </span>
            <div>
              <h2 className="text-lg font-black tracking-tight">Recomandate de OXO</h2>
              <p className="text-sm text-slate-400">Utilaje verificate de la producători și parteneri oficiali.</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.slice(0, 3).map((it, i) => (
            <Link key={it.id} to={`/anunt/${it.id}`}
              className="group relative bg-slate-800 border border-slate-700 hover:border-amber-500 transition-colors flex flex-col overflow-hidden"
              data-testid={`showroom-card-${it.id}`}>
              <div className="relative aspect-[16/10] overflow-hidden bg-slate-700">
                <img src={mediaUrl(it.image) || PLACEHOLDER} alt={it.name}
                  loading={i < 3 ? "eager" : "lazy"} fetchPriority={i < 3 ? "high" : "auto"}
                  onError={(e) => { e.currentTarget.src = PLACEHOLDER; }}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                {it.ai_verified_price && (
                  <span className="absolute top-0 right-0 inline-flex items-center gap-1 bg-amber-500 text-slate-900 text-[10px] font-black uppercase tracking-wider px-2.5 py-1.5">
                    <BadgeCheck className="w-3.5 h-3.5" /> AI Verified Price
                  </span>
                )}
              </div>
              <div className="p-4 flex-1 flex flex-col">
                {it.brand && <span className="text-[11px] font-bold uppercase tracking-widest text-amber-400">{it.brand}</span>}
                <h3 className="font-bold leading-snug mt-1 line-clamp-2 group-hover:text-amber-300 transition-colors">{it.name}</h3>
                <div className="mt-auto pt-3 flex items-end justify-between">
                  <span className="text-lg font-black">
                    {it.price_on_request || !it.price ? "La cerere" : formatRON(it.price)}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-amber-400 group-hover:gap-2 transition-all">
                    Detalii <ArrowRight className="w-3.5 h-3.5" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
